(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luniora-before-after-results"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-luniora-results]').forEach((carousel) => {
        if (carousel.dataset.resultsInitialized === 'true') return;

        const track = carousel.querySelector('[data-results-track]');
        const cards = Array.from(track?.querySelectorAll('.luniora-results__card') || []);
        const dots = Array.from(carousel.querySelectorAll('[data-results-dot]'));

        if (!track || cards.length < 2 || dots.length !== cards.length) return;

        carousel.dataset.resultsInitialized = 'true';

        const mobileQuery = window.matchMedia('(max-width: 749px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const autoplayEnabled = carousel.dataset.autoplay === 'true';
        const autoplaySpeed = Number(carousel.dataset.autoplaySpeed) || 5000;
        let activeIndex = 0;
        let autoplayTimer;
        let scrollTimer;

        const setActive = (index) => {
          activeIndex = index;
          dots.forEach((dot, dotIndex) => {
            const active = dotIndex === index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
        };

        const goTo = (index, behavior = 'smooth') => {
          const nextIndex = (index + cards.length) % cards.length;
          track.scrollTo({ left: cards[nextIndex].offsetLeft, behavior });
          setActive(nextIndex);
        };

        const stopAutoplay = () => {
          window.clearInterval(autoplayTimer);
          autoplayTimer = undefined;
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (!autoplayEnabled || !mobileQuery.matches || reducedMotion.matches || document.hidden) return;
          autoplayTimer = window.setInterval(() => goTo(activeIndex + 1), autoplaySpeed);
        };

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            goTo(index);
            startAutoplay();
          });
        });

        track.addEventListener('scroll', () => {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(() => {
            const index = cards.reduce((nearest, card, cardIndex) => {
              const currentDistance = Math.abs(card.offsetLeft - track.scrollLeft);
              const nearestDistance = Math.abs(cards[nearest].offsetLeft - track.scrollLeft);
              return currentDistance < nearestDistance ? cardIndex : nearest;
            }, 0);
            setActive(index);
          }, 80);
        }, { passive: true });

        track.addEventListener('touchstart', stopAutoplay, { passive: true });
        track.addEventListener('touchend', startAutoplay, { passive: true });
        carousel.addEventListener('focusin', stopAutoplay);
        carousel.addEventListener('focusout', startAutoplay);
        mobileQuery.addEventListener('change', startAutoplay);
        document.addEventListener('visibilitychange', startAutoplay);
        startAutoplay();
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luniora-customer-result-cards"] && !Shopify.designMode) return;
  try {
    
  class CustomerResultCards extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.track = this.querySelector('[data-result-cards-track]');
      this.cards = [...this.querySelectorAll('[data-result-card]')];
      this.currentIndex = 0;
      this.timer = null;
      this.isVisible = true;
      this.scrollFrame = null;

      if (!this.track || this.cards.length < 2) return;

      this.onScroll = () => {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updateCurrentIndex());
      };

      this.onResize = () => {
        this.updateCurrentIndex();
        this.restart();
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('pointerenter', () => this.stop());
      this.addEventListener('pointerleave', () => this.start());
      this.addEventListener('touchstart', () => this.stop(), { passive: true });
      this.addEventListener('touchend', () => this.restart(), { passive: true });
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.start();
      });
      window.addEventListener('resize', this.onResize);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              this.start();
            } else {
              this.stop();
            }
          },
          { threshold: 0.2 }
        );
        this.observer.observe(this);
      }

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.track?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.observer?.disconnect();
    }

    canScroll() {
      return this.track.scrollWidth > this.track.clientWidth + 2;
    }

    updateCurrentIndex() {
      const trackLeft = this.track.getBoundingClientRect().left;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.currentIndex = closestIndex;
    }

    goTo(index) {
      const safeIndex = Math.max(0, Math.min(this.cards.length - 1, index));
      const card = this.cards[safeIndex];
      if (!card) return;

      const left = card.offsetLeft - this.track.offsetLeft;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollTo({
        left,
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
      this.currentIndex = safeIndex;
    }

    start() {
      if (
        this.dataset.autoplay !== 'true' ||
        !this.isVisible ||
        !this.canScroll() ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      this.stop();
      const interval = Number(this.dataset.interval) || 5000;

      this.timer = window.setInterval(() => {
        const nextIndex = this.currentIndex >= this.cards.length - 1 ? 0 : this.currentIndex + 1;
        this.goTo(nextIndex);
      }, interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('customer-result-cards')) {
    customElements.define('customer-result-cards', CustomerResultCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luniora-sale-offer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sale-offer-action]');
    if (!trigger) return;

    const action = trigger.dataset.saleOfferAction;
    const productArea =
      document.querySelector('product-information') ||
      document.querySelector('[data-product-information]') ||
      document.querySelector('.product-information');
    const addButton =
      productArea?.querySelector('button.add-to-cart-button:not([disabled])') ||
      document.querySelector('button.add-to-cart-button:not([disabled])');
    const purchaseArea =
      addButton?.closest('.product-form-buttons') ||
      productArea?.querySelector('.product-form-buttons') ||
      addButton;

    if (action === 'add_to_cart' && addButton) {
      addButton.click();
      return;
    }

    if (purchaseArea) {
      purchaseArea.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center'
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
